/**
 * 审批管理相关接口
 */
import request from '../utils/axios'

/* 采伐证审批相关接口*/

export function GetlicenceApproveAllList(data) {
  return request({
    url: "/CutLicense/GetAllList",
    method: "POST",
    data
  })
}

// 审批采伐证
export function ApprovalCutLicense(data) {
  return request({
    url: "/CutLicense/SetState",
    method: "POST",
    data
  })
}

// 获取审批采伐证详情
export function GetlicenceApproveDetails(data) {
  return request({
    url: `/CutLicense/GetDetails?id=${data.id}`,
    method: "get"
  })
}
// 获取审批采伐证详情
export function GetlicenceApproveDetails2(data) {
  return request({
    url: `/CutLicense/GetDetails2?id=${data.id}`,
    method: "get"
  })
}

// 删除审批采伐证数据
export function DeletelicenceApprove(data) {
  return request({
    url: `/CutLicense/Delete`,
    method: "post",
		data
  })
}


// 获取实地审核信息
export function GetSDSHInfo(id) {
  return request({
    url: `/CutLicense/GetSDSHInfo?id=${id}`,
    method: "get"
  })
}

// 获取采伐证编号信息
export function VerifyCaiFaZheng(code) {
  return request({
    url: `/CutLicense/VerifyCaiFaZheng?code=${code}`,
    method: "get"
  })
}
// 获取图形数据（工作人员）
export function GetShps(data) {
  return request({
    url: `/CutLicense/GetShps?id=${data.id}&type=${data.type}`,
    method: "get"
  })
}

// 获取我的列表（普通用户）
export function GetMyList() {
  return request({
    url: `/CutLicense/GetMyList`,
    method: "get"
  })
}

// 补充材料（普通用户）
export function PerfectDicLicense(params) {
  return request({
    url: `/CutLicense/PerfectDicLicense`,
    method: "post",
		data:params
  })
}

// 获取采伐证审批下拉框（工作人员）
export function GetListBox(params) {
  return request({
    url: `/CutLicense/GetListBox`,
    method: "get"
  })
}

// 获取所有采伐证审批表(工作人员)
export function GetAllReviceHistoryList(id) {
  return request({
    url: `/CutLicense/GetAllReviceHistoryList?id=${id}`,
    method: "get"
  })
}

//获取审批认证数量（工作人员）
export function GetAttestationCount() {
  return request({
    url: `/CutLicense/GetAttestationCount`,
    method: "get"
  })
}

// 编辑审核表（工作人员）
export function Edit(params) {
  return request({
    url: `/CutLicense/Edit`,
    method: "post",
		data:params
  })
}

// 获取我申请表（普通用户和设计公司）
export function GetMyapplysFormPhone(data) {
  return request({
    url: "/CutLicense/GetMyapplysFormPhone",
    method: "POST",
    data
  })
}